var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.709874 16.953L9.33228 1.86383C10.0846 0.54727 11.9712 0.514099 12.7693 1.8034L22.1102 16.8926C22.935 18.225 21.9767 19.9453 20.4097 19.9453H2.44636C0.910714 19.9453 -0.0520195 18.2863 0.709874 16.953Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTriangle);
export default __webpack_public_path__ + "static/media/yellow-triangle.afe082e422bda96c903ac39c8ecb0b73.svg";
export { ForwardRef as ReactComponent };